import { CoreIcon } from '../core-icon';
import appLineappSVG from '../../../src/images/logos/app-lineapp.svg';

export const AppLineappIcon = props => {
  return <CoreIcon src={appLineappSVG} {...props} />;
};
